import { render } from "./DefaultLayout.vue?vue&type=template&id=71846e54"
const script = {}

import exportComponent from "/home/ubuntu/epr-survey-builder/Vue_Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__